import {
  PREVIEW_AGE_DISTRIBUTION_ROWS,
  PREVIEW_AR_OPPORTUNITY_ROWS,
  PREVIEW_CC_CALLS_KPI_SUMMARY_ROWS,
  PREVIEW_CC_CALLS_VOLUME_ROWS,
  PREVIEW_CC_EFFECTIVENESS_ROWS,
  PREVIEW_CC_MESSAGING_KPI_SUMMARY_ROWS,
  PREVIEW_CC_MESSAGING_ROWS,
  PREVIEW_CFE_COLLECTIONS_ROWS,
  PREVIEW_CFE_NET_COLLECTION_ROWS,
  PREVIEW_CFE_PRODUCTION_REFERENCE_ROWS,
  PREVIEW_CFE_SAME_DAY_ROWS,
  PREVIEW_CFE_SUMMARY_ROWS,
  PREVIEW_CLAIMS_AGING_ROWS,
  PREVIEW_CLAIMS_CARRIER_ROWS,
  PREVIEW_CLAIMS_PAYMENT_TREND_ROWS,
  PREVIEW_CLAIMS_STATUS_ROWS,
  PREVIEW_CLAIMS_SUMMARY_ROWS,
  PREVIEW_CMT_CROWN_ROWS,
  PREVIEW_CMT_EXTRACTION_ROWS,
  PREVIEW_CMT_FILLING_ROWS,
  PREVIEW_CMT_SRP_ROWS,
  PREVIEW_CMT_SUMMARY_ROWS,
  PREVIEW_CRU_CHAIR_TIME_ROWS,
  PREVIEW_CRU_OPERATIONS_EFFICIENCY_ROWS,
  PREVIEW_CRU_PROVIDERS_WORKING_ROWS,
  PREVIEW_CRU_SUMMARY_ROWS,
  PREVIEW_ES_CHAIR_UTILIZATION_ROWS,
  PREVIEW_ES_EFFICIENCY_SCORE_ROWS,
  PREVIEW_ES_PRODUCTION_PER_HOUR_ROWS,
  PREVIEW_ES_PROVIDER_COMPARISON_ROWS,
  PREVIEW_ES_SUMMARY_ROWS,
  PREVIEW_FAMILY_OPPORTUNITY_BIRTHDAY_ROWS,
  PREVIEW_FAMILY_OPPORTUNITY_HOUSEHOLD_GAP_ROWS,
  PREVIEW_FAMILY_OPPORTUNITY_MULTI_GAP_ROWS,
  PREVIEW_FAMILY_OPPORTUNITY_SUMMARY_ROWS,
  PREVIEW_GAV_COLLECTION_ROWS,
  PREVIEW_GAV_LOCATION_ROWS,
  PREVIEW_GAV_PRODUCTION_ROWS,
  PREVIEW_GAV_PROVIDER_ROWS,
  PREVIEW_GAV_RUN_RATE_ROWS,
  PREVIEW_GAV_SUMMARY_ROWS,
  PREVIEW_GAV_VARIANCE_TREND_ROWS,
  PREVIEW_GAV_YTD_ROWS,
  PREVIEW_HIGH_RISK_ROWS,
  PREVIEW_HP_OPENINGS_ROWS,
  PREVIEW_HP_REACTIVATION_ROWS,
  PREVIEW_HP_RECALL_COMPLIANCE_ROWS,
  PREVIEW_HP_SUMMARY_ROWS,
  PREVIEW_HP_UTILIZATION_ROWS,
  PREVIEW_HYGIENE_OVERDUE_ACTION_ROWS,
  PREVIEW_MCP_CHANNEL_PERFORMANCE_ROWS,
  PREVIEW_MCP_FUNNEL_ROWS,
  PREVIEW_MCP_MONTHLY_TREND_ROWS,
  PREVIEW_MCP_SUMMARY_KPI_ROWS,
  PREVIEW_MEDICAL_ALERTS_DETAIL_ROWS,
  PREVIEW_NEW_VS_EXISTING_ROWS,
  PREVIEW_OBT_DAILY_TASKS_ROWS,
  PREVIEW_OBT_EXPECTED_AR_ROWS,
  PREVIEW_OBT_LAB_FOLLOW_UPS_ROWS,
  PREVIEW_OBT_OVERDUE_CLAIMS_ROWS,
  PREVIEW_OBT_SUMMARY_ROWS,
  PREVIEW_OVERDUE_GROUPING_ROWS,
  PREVIEW_PATIENT_VALUE_SUMMARY_ROWS,
  PREVIEW_POPULATION_TREND_ROWS,
  PREVIEW_PP_PER_DAY_ROWS,
  PREVIEW_PP_PER_HOUR_ROWS,
  PREVIEW_PP_PRODUCTION_GOAL_ROWS,
  PREVIEW_PP_PRODUCTION_ROWS,
  PREVIEW_PP_SUMMARY_ROWS,
  PREVIEW_PROCEDURE_MIX_ROWS,
  PREVIEW_REACTIVATION_TREND_ROWS,
  PREVIEW_RECALL_COMPLIANCE_TREND_ROWS,
  PREVIEW_RECALL_REACTIVATION_COMPLIANCE_ROWS,
  PREVIEW_RECALL_REACTIVATION_PROVIDER_ROWS,
  PREVIEW_RECALL_REACTIVATION_SUMMARY_ROWS,
  PREVIEW_REFERRAL_FEEDBACK_CHANNEL_ROWS,
  PREVIEW_REFERRAL_MONTHLY_REFERRALS_ROWS,
  PREVIEW_REFERRAL_NPS_TREND_ROWS,
  PREVIEW_REFERRAL_REVENUE_MONTHLY_ROWS,
  PREVIEW_REFERRAL_SUMMARY_KPI_ROWS,
  PREVIEW_RISK_COMPLIANCE_SUMMARY_ROWS,
  PREVIEW_RRA_ADJUSTMENT_RATE_ROWS,
  PREVIEW_RRA_INSURANCE_VS_PATIENT_ROWS,
  PREVIEW_RRA_NET_COLLECTION_ROWS,
  PREVIEW_RRA_PRODUCTION_VS_COLLECTIONS_ROWS,
  PREVIEW_RRA_SUMMARY_ROWS,
  PREVIEW_RRISK_AGING_ROWS,
  PREVIEW_RRISK_AR_TREND_ROWS,
  PREVIEW_RRISK_AVG_DAYS_ROWS,
  PREVIEW_RRISK_HIGH_BALANCE_ROWS,
  PREVIEW_RRISK_SUMMARY_ROWS,
  PREVIEW_SA_FILLED_OPEN_ROWS,
  PREVIEW_SA_HYGIENE_GAPS_ROWS,
  PREVIEW_SA_NO_SHOWS_ROWS,
  PREVIEW_SA_PRODUCTION_ROWS,
  PREVIEW_SA_SUMMARY_ROWS,
  PREVIEW_SCHEDULE_RELIABILITY_CANCELLATION_PATTERN_ROWS,
  PREVIEW_SCHEDULE_RELIABILITY_NO_SHOW_PATIENT_ROWS,
  PREVIEW_SCHEDULE_RELIABILITY_REPEAT_OFFENDER_ROWS,
  PREVIEW_SCHEDULE_RELIABILITY_SUMMARY_ROWS,
  PREVIEW_SCHEDULE_RELIABILITY_TREND_ROWS,
  PREVIEW_SUMMARY_ROWS,
  PREVIEW_TE_ACCEPTANCE_RATE_ROWS,
  PREVIEW_TE_COMPLETED_VS_DIAGNOSED_ROWS,
  PREVIEW_TE_DIAGNOSED_VOLUME_ROWS,
  PREVIEW_TE_STATUS_DISTRIBUTION_ROWS,
  PREVIEW_TE_SUMMARY_ROWS,
  PREVIEW_TE_UNSCHEDULED_ROWS,
  PREVIEW_UNSCHEDULED_BUCKET_ROWS,
  PREVIEW_VALUE_SEGMENTS_ROWS,
  PREVIEW_VISIT_ROWS,
} from '@assets/mockdata/Reports/preview'
import {
  EXAM_UNSCHEDULED_PROVIDER_ROWS,
  PREVIEW_TCF_COMPLETED_VS_DIAGNOSED_MONTHLY,
  PREVIEW_TCF_FUNNEL_STAGE_PREVIEW_ROWS,
  PREVIEW_TCF_SUMMARY_KPI_ROWS,
  PREVIEW_TCF_VALUE_BUCKET_PREVIEW_ROWS,
} from '@constants/Reports/treatmentConversionFunnel.constants'
import type { Provider } from '@dataTypes/provider.types'

type SampleMetricDefinition = {
  data?: unknown
  data2?: unknown
  extendedBlocks?: Array<{ data?: unknown }>
}

type SamplePayloadData = {
  data?: unknown
  data2?: unknown
  extendedData?: unknown[]
}

export const SAMPLE_METRICS_DATA: Record<string, SampleMetricDefinition> = {
  //patient-base-health
  summary: {
    data: PREVIEW_SUMMARY_ROWS,
  },
  lastVisitDistribution: {
    data: PREVIEW_VISIT_ROWS,
  },
  patientPopulationTrend: {
    data: PREVIEW_POPULATION_TREND_ROWS,
  },
  patientAgeDistribution: {
    data: PREVIEW_AGE_DISTRIBUTION_ROWS,
  },
  highRiskPatients: {
    data: PREVIEW_HIGH_RISK_ROWS,
  },
  //patient-value-rev-distribution
  pvSummary: {
    data: PREVIEW_PATIENT_VALUE_SUMMARY_ROWS,
  },
  pvProductionMix: {
    data: PREVIEW_PROCEDURE_MIX_ROWS,
    data2: PREVIEW_VALUE_SEGMENTS_ROWS,
  },
  pvNewVsExisting: {
    data: PREVIEW_NEW_VS_EXISTING_ROWS,
  },
  pvArOpportunity: {
    data: PREVIEW_AR_OPPORTUNITY_ROWS,
  },
  //patient-risk-compliance
  prSummary: {
    data: PREVIEW_RISK_COMPLIANCE_SUMMARY_ROWS,
  },
  prRecallTrend: {
    data: PREVIEW_RECALL_COMPLIANCE_TREND_ROWS,
  },
  prUnscheduled: {
    data: PREVIEW_UNSCHEDULED_BUCKET_ROWS,
  },
  prOverdue: {
    data: PREVIEW_OVERDUE_GROUPING_ROWS,
  },
  prMedicalAlerts: {
    data: PREVIEW_MEDICAL_ALERTS_DETAIL_ROWS,
  },
  //family-opportunity-intelligence
  foSummary: {
    data: PREVIEW_FAMILY_OPPORTUNITY_SUMMARY_ROWS,
  },
  foBirthdays: {
    data: PREVIEW_FAMILY_OPPORTUNITY_BIRTHDAY_ROWS,
  },
  foMultiFamily: {
    data: PREVIEW_FAMILY_OPPORTUNITY_MULTI_GAP_ROWS,
  },
  foHouseholdGaps: {
    data: PREVIEW_FAMILY_OPPORTUNITY_HOUSEHOLD_GAP_ROWS,
  },
  //recall-reactivation-control
  rrSummary: {
    data: PREVIEW_RECALL_REACTIVATION_SUMMARY_ROWS,
  },
  rrRecallTrend: {
    data: PREVIEW_RECALL_REACTIVATION_COMPLIANCE_ROWS,
  },
  rrProvider: {
    data: PREVIEW_RECALL_REACTIVATION_PROVIDER_ROWS,
  },
  rrReactivationTrend: {
    data: PREVIEW_REACTIVATION_TREND_ROWS,
  },
  rrHygieneOverdue: {
    data: PREVIEW_HYGIENE_OVERDUE_ACTION_ROWS,
  },
  //schedule-reliability
  srSummary: {
    data: PREVIEW_SCHEDULE_RELIABILITY_SUMMARY_ROWS,
  },
  srRateTrend: {
    data: PREVIEW_SCHEDULE_RELIABILITY_TREND_ROWS,
  },
  srNoShowList: {
    data: PREVIEW_SCHEDULE_RELIABILITY_NO_SHOW_PATIENT_ROWS,
  },
  srRepeatOffenders: {
    data: PREVIEW_SCHEDULE_RELIABILITY_REPEAT_OFFENDER_ROWS,
  },
  srCancellationPattern: {
    data: PREVIEW_SCHEDULE_RELIABILITY_CANCELLATION_PATTERN_ROWS,
  },
  //treatment-conversion-funnel
  tcfSummary: {
    data: PREVIEW_TCF_SUMMARY_KPI_ROWS,
    extendedBlocks: [
      {
        data: PREVIEW_TCF_FUNNEL_STAGE_PREVIEW_ROWS,
      },
    ],
  },
  tcfOpportunities: {
    data: PREVIEW_TCF_VALUE_BUCKET_PREVIEW_ROWS,
  },
  tcfProvider: {
    data: EXAM_UNSCHEDULED_PROVIDER_ROWS,
  },
  tcfMonthly: {
    data: PREVIEW_TCF_COMPLETED_VS_DIAGNOSED_MONTHLY,
  },
  //referral-reputation
  refSummary: {
    data: PREVIEW_REFERRAL_SUMMARY_KPI_ROWS,
    extendedBlocks: [
      {
        data: PREVIEW_REFERRAL_MONTHLY_REFERRALS_ROWS,
      },
    ],
  },
  rrRevenueMonthly: {
    data: PREVIEW_REFERRAL_REVENUE_MONTHLY_ROWS,
  },
  rrNpsTrend: {
    data: PREVIEW_REFERRAL_NPS_TREND_ROWS,
  },
  rrFeedbackChannels: {
    data: PREVIEW_REFERRAL_FEEDBACK_CHANNEL_ROWS,
  },
  //marketing-campaign-performance
  mcpSummary: {
    data: PREVIEW_MCP_SUMMARY_KPI_ROWS,
  },
  mcpMonthlyTrend: {
    data: PREVIEW_MCP_MONTHLY_TREND_ROWS,
  },
  mcpConversionFunnel: {
    data: PREVIEW_MCP_FUNNEL_ROWS,
  },
  mcpChannelPerformance: {
    data: PREVIEW_MCP_CHANNEL_PERFORMANCE_ROWS,
  },
  //communication-center-performance
  ccCallsKpiSummary: {
    data: PREVIEW_CC_CALLS_KPI_SUMMARY_ROWS,
  },
  ccMessagingKpiSummary: {
    data: PREVIEW_CC_MESSAGING_KPI_SUMMARY_ROWS,
  },
  ccEffectiveness: {
    data: PREVIEW_CC_EFFECTIVENESS_ROWS,
  },
  ccCallsVolume: {
    data: PREVIEW_CC_CALLS_VOLUME_ROWS,
  },
  ccMessaging: {
    data: PREVIEW_CC_MESSAGING_ROWS,
  },
  //scheduled-appointments
  saSummary: {
    data: PREVIEW_SA_SUMMARY_ROWS,
  },
  saNoShows: {
    data: PREVIEW_SA_NO_SHOWS_ROWS,
  },
  saFilledOpen: {
    data: PREVIEW_SA_FILLED_OPEN_ROWS,
  },
  saHygieneGaps: {
    data: PREVIEW_SA_HYGIENE_GAPS_ROWS,
  },
  saProductionTargetScheduled: {
    data: PREVIEW_SA_PRODUCTION_ROWS,
  },
  //chair-room-utilization
  cruSummary: {
    data: PREVIEW_CRU_SUMMARY_ROWS,
  },
  cruChairTime: {
    data: PREVIEW_CRU_CHAIR_TIME_ROWS,
  },
  cruProvidersWorking: {
    data: PREVIEW_CRU_PROVIDERS_WORKING_ROWS,
  },
  cruOperationsEfficiency: {
    data: PREVIEW_CRU_OPERATIONS_EFFICIENCY_ROWS,
  },
  //hygiene-performance
  hpSummary: {
    data: PREVIEW_HP_SUMMARY_ROWS,
  },
  hpOpenings: {
    data: PREVIEW_HP_OPENINGS_ROWS,
  },
  hpUtilization: {
    data: PREVIEW_HP_UTILIZATION_ROWS,
  },
  hpRecallCompliance: {
    data: PREVIEW_HP_RECALL_COMPLIANCE_ROWS,
  },
  hpReactivationSuccess: {
    data: PREVIEW_HP_REACTIVATION_ROWS,
  },
  //operational-backlog-tasks
  obtSummary: {
    data: PREVIEW_OBT_SUMMARY_ROWS,
  },
  obtLabFollowUps: {
    data: PREVIEW_OBT_LAB_FOLLOW_UPS_ROWS,
  },
  obtOverdueClaims: {
    data: PREVIEW_OBT_OVERDUE_CLAIMS_ROWS,
  },
  obtDailyTasks: {
    data: PREVIEW_OBT_DAILY_TASKS_ROWS,
  },
  obtExpectedAr: {
    data: PREVIEW_OBT_EXPECTED_AR_ROWS,
  },
  //production-performance
  ppSummary: {
    data: PREVIEW_PP_SUMMARY_ROWS,
  },
  ppProduction: {
    data: PREVIEW_PP_PRODUCTION_ROWS,
  },
  ppProductionGoal: {
    data: PREVIEW_PP_PRODUCTION_GOAL_ROWS,
  },
  ppPerHour: {
    data: PREVIEW_PP_PER_HOUR_ROWS,
  },
  ppPerDay: {
    data: PREVIEW_PP_PER_DAY_ROWS,
  },
  //collections-financial-efficiency
  cfeSummary: {
    data: PREVIEW_CFE_SUMMARY_ROWS,
  },
  cfeCollections: {
    data: PREVIEW_CFE_COLLECTIONS_ROWS,
  },
  cfeNetCollection: {
    data: PREVIEW_CFE_NET_COLLECTION_ROWS,
  },
  cfeSameDay: {
    data: PREVIEW_CFE_SAME_DAY_ROWS,
  },
  cfeProductionRef: {
    data: PREVIEW_CFE_PRODUCTION_REFERENCE_ROWS,
  },
  //clinical-mix-treatment-profile
  cmtSummary: {
    data: PREVIEW_CMT_SUMMARY_ROWS,
  },
  cmtCrown: {
    data: PREVIEW_CMT_CROWN_ROWS,
  },
  cmtSrp: {
    data: PREVIEW_CMT_SRP_ROWS,
  },
  cmtFilling: {
    data: PREVIEW_CMT_FILLING_ROWS,
  },
  cmtExtraction: {
    data: PREVIEW_CMT_EXTRACTION_ROWS,
  },
  //treatment-effectiveness
  teSummary: {
    data: PREVIEW_TE_SUMMARY_ROWS,
  },
  teStatusDistribution: {
    data: PREVIEW_TE_STATUS_DISTRIBUTION_ROWS,
  },
  teAcceptance: {
    data: PREVIEW_TE_ACCEPTANCE_RATE_ROWS,
  },
  teCompleted: {
    data: PREVIEW_TE_COMPLETED_VS_DIAGNOSED_ROWS,
  },
  teDiagnosed: {
    data: PREVIEW_TE_DIAGNOSED_VOLUME_ROWS,
  },
  teUnscheduled: {
    data: PREVIEW_TE_UNSCHEDULED_ROWS,
  },
  //efficiency-scorecard
  esSummary: {
    data: PREVIEW_ES_SUMMARY_ROWS,
  },
  esEfficiency: {
    data: PREVIEW_ES_EFFICIENCY_SCORE_ROWS,
  },
  esProductionPerHour: {
    data: PREVIEW_ES_PRODUCTION_PER_HOUR_ROWS,
  },
  esChairUtilization: {
    data: PREVIEW_ES_CHAIR_UTILIZATION_ROWS,
  },
  esProviderComparison: {
    data: PREVIEW_ES_PROVIDER_COMPARISON_ROWS,
  },
  //revenue-realization-analytics
  rraSummary: {
    data: PREVIEW_RRA_SUMMARY_ROWS,
  },
  rraProdVsColl: {
    data: PREVIEW_RRA_PRODUCTION_VS_COLLECTIONS_ROWS,
  },
  rraNetCollection: {
    data: PREVIEW_RRA_NET_COLLECTION_ROWS,
  },
  rraAdjustmentRate: {
    data: PREVIEW_RRA_ADJUSTMENT_RATE_ROWS,
  },
  rraInsuranceVsPatient: {
    data: PREVIEW_RRA_INSURANCE_VS_PATIENT_ROWS,
  },
  //receivables-risk-analysis
  rriskSummary: {
    data: PREVIEW_RRISK_SUMMARY_ROWS,
  },
  rriskAging: {
    data: PREVIEW_RRISK_AGING_ROWS,
  },
  rriskArTrend: {
    data: PREVIEW_RRISK_AR_TREND_ROWS,
  },
  rriskAvgDays: {
    data: PREVIEW_RRISK_AVG_DAYS_ROWS,
  },
  rriskHighBalance: {
    data: PREVIEW_RRISK_HIGH_BALANCE_ROWS,
  },
  //claims-performance
  claimsSummary: {
    data: PREVIEW_CLAIMS_SUMMARY_ROWS,
  },
  claimsPaymentTrend: {
    data: PREVIEW_CLAIMS_PAYMENT_TREND_ROWS,
  },
  claimsStatus: {
    data: PREVIEW_CLAIMS_STATUS_ROWS,
  },
  claimsCarrier: {
    data: PREVIEW_CLAIMS_CARRIER_ROWS,
  },
  claimsAging: {
    data: PREVIEW_CLAIMS_AGING_ROWS,
  },
  //goal-attainment-variance
  gavSummary: {
    data: PREVIEW_GAV_SUMMARY_ROWS,
  },
  gavYtd: {
    data: PREVIEW_GAV_YTD_ROWS,
  },
  gavRunRate: {
    data: PREVIEW_GAV_RUN_RATE_ROWS,
  },
  gavVarianceTrend: {
    data: PREVIEW_GAV_VARIANCE_TREND_ROWS,
  },
  gavProduction: {
    data: PREVIEW_GAV_PRODUCTION_ROWS,
  },
  gavCollection: {
    data: PREVIEW_GAV_COLLECTION_ROWS,
  },
  gavLocation: {
    data: PREVIEW_GAV_LOCATION_ROWS,
  },
  gavProvider: {
    data: PREVIEW_GAV_PROVIDER_ROWS,
  },
}

export type CustomReportCategory = {
  id: string
  label: string
}

export const getProviderName = (
  provider:
    | Pick<Provider, 'first_name' | 'middle_name' | 'last_name'>
    | null
    | undefined,
): string => {
  if (!provider) return ''
  return `Dr. ${provider.first_name} ${provider.middle_name?.charAt(0) + '.' || ''} ${provider.last_name}`
}

export const getSamplePayloadData = (metricId: string): SamplePayloadData => {
  return {
    data: SAMPLE_METRICS_DATA[metricId]?.data,
    data2: SAMPLE_METRICS_DATA[metricId]?.data2,
    extendedData: SAMPLE_METRICS_DATA[metricId]?.extendedBlocks?.map(
      (block) => block.data,
    ),
  }
}
